import { createHashRouter } from "react-router-dom";
import {
  faChartSimple,
  faDisplay,
  faGears,
  faHouse,
  faMessage,
  faSterlingSign,
  faTicketSimple,
  faWeightHanging,
  faFolderOpen,
  faTruckMoving,
  faToolbox,
  faTruckPickup,
  faWifi,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";

import App from "../../App";
import LoginPage from "../../page/login/LoginPage";
import { DashboardLayout } from "../../page/dashboard/DashboardLayout";
import HomePage from "../../page/dashboard/home/HomePage";
import Callback from "../../page/callback/Callback";
import JobListPage from "../../page/dashboard/job-list/JobListPage";
import InvoicePage from "../../page/dashboard/invoice/InvoicePage";
import DocumentsPage from "../../page/dashboard/documents/DocumentsPage";
import ReportingPage from "../../page/dashboard/reporting/ReportingPage";
import SustainabilityAuditsPage from "../../page/dashboard/audits/SustainabilityAuditsPage";
import ResetPasswordPage from "../../page/reset-password/ResetPasswordPage";
import WeightingPage from "../../page/dashboard/weighting/WeightingPage";
import ConfirmAccount from "../../page/confirm-account/ConfirmAccount";
import { JobStatusDataEntry } from "./interfaces";
import DonatePage from "../../page/dashboard/donate/DonatePage";
import ApiConnections from "../../page/dashboard/api-connections/ApiConnections";
import ApiDashboardPage from "../../page/dashboard/api-dashboard/ApiDashboardPage";

export enum DataCacheKey {
  TOKEN_KEY = "TOKEN",
  USER_OVERALL_DATA_KEY = "OVERALL_DATA",
  FILTER_DATA_KEY = "FILTER_DATA",
}

export enum SortOrder {
  Ascending,
  Descending,
}

export enum InvoiceType {
  INVOICE,
  CREDIT,
}

export enum DocumentType {
  CONTRACT_ATTACHMENT,
  AGREEMENT_ATTACHMENT,
  DUTY_OF_CARE,
  CONTRACT_ATTACHMENT_SF,
  WTN_ATTACHMENT_SF,
}

export enum DataType {
  WASTE_TYPE_PERCENTAGE = "WTChart",
  WASTE_TYPE_PERCENTAGE_PRINTABLE = "WTReportTable",
  WASTE_RECOVERED_RECYCLED = "RRChart",
  CO2_EMISSIONS = "EmissionsChart",
//   LB_RECYCLING_RATE = "LB_RecyclingRateReportTable",
//   LB_EMISSIONS_RATE = "LB_EmissionsRateReportTable",
//   LB_REDUCED_WASTE = "LB_ReducedWasteReportTable",

  LB_RECYCLING_RATE_TOP = "LB_RecyclingRateTOP",
  LB_EMISSIONS_RATE_TOP = "LB_EmissionsRateTOP",
  LB_REDUCED_WASTE_TOP = "LB_ReducedWasteTOP",
  LB_RECYCLING_RATE_BOTTOM = "LB_RecyclingRateBOTTOM",
  LB_EMISSIONS_RATE_BOTTOM = "LB_EmissionsRateBOTTOM",
  LB_REDUCED_WASTE_BOTTOM = "LB_ReducedWasteBOTTOM",

  WASTE_TYPE_BY_PERIOD = "WTChartByPeriod",
  WASTE_TYPE_BY_SITE = "WTChartBySite",
//   LB_RECYCLING_RATE_TOP = "LB_RecyclingRateTOP",
//   LB_EMISSIONS_RATE_BOTTOM = "LB_EmissionsRateBOTTOM",
//   LB_REDUCED_WASTE_TOP = "LB_ReducedWasteTOP",
}

export enum JobStatus {
  NEW = 1,
  ALLOCATED = 2,
  ON_STOP = 3,
  CANCELLED = 4,
  COMPLETED = 5,
  FAILED = 6,
  POSTPONED = 7,
}

// Routing
export const router = createHashRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "home",
        element: <HomePage />,
      },
      {
        path: "job-list",
        element: <JobListPage />,
      },
      {
        path: "reporting",
        element: <ReportingPage />,
      },
      {
        path: "weighting-platforms",
        element: <WeightingPage />,
      },
      {
        path: "api-dashboard",
        element: <ApiDashboardPage />,
      },
      {
        path: "api-connections",
        element: <ApiConnections />,
      },
      {
        path: "invoices",
        element: <InvoicePage />,
      },
      {
        path: "audit",
        element: <SustainabilityAuditsPage />,
      },
      {
        path: "documents",
        element: <DocumentsPage />,
      },
      {
        path: "donate",
        element: <DonatePage />,
      },
    ],
  },
  {
    path: "/auth/microsoft/callback",
    element: <Callback />,
  },
  {
    path: "/account-confirmation",
    element: <ConfirmAccount />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
]);

export const linkLabels = [
  {
    name: "Homepage",
    path: "/dashboard/home",
    icon: faHouse,
    isInternal: true,
  },
  {
    name: "Job List & Issues",
    path: "/dashboard/job-list",
    icon: faChartSimple,
    isInternal: true,
  },
  {
    name: "Reporting",
    path: "/dashboard/reporting",
    icon: faMessage,
    isInternal: true,
  },
  {
    name: "Weighting Platform",
    path: "/dashboard/weighting-platforms",
    icon: faWeightHanging,
    isInternal: true,
  },
//   {
//     name: "API Connections Dashboard",
//     path: "/dashboard/api-dashboard",
//     icon: faNetworkWired,
//     isInternal: true,
//   },
//   {
//     name: "Add New API Connection",
//     path: "/dashboard/api-connections",
//     icon: faWifi,
//     isInternal: true,
//   },
  {
    name: "Invoices",
    path: "/dashboard/invoices",
    icon: faSterlingSign,
    isInternal: true,
  },
  {
    name: "Sustainability Audits",
    path: "/dashboard/audit",
    icon: faGears,
    isInternal: true,
  },
  {
    name: "Documents",
    path: "/dashboard/documents",
    icon: faDisplay,
    isInternal: true,
  },
  {
    name: "Accreditations",
    path: "https://www.bywaters.co.uk/about/accreditations",
    icon: faTicketSimple,
    isInternal: false,
  },
  {
    name: "Services",
    path: "https://www.bywaters.co.uk/services",
    icon: faTruckMoving,
    isInternal: false,
  },
  {
    name: "Equipment",
    path: "https://www.bywaters.co.uk/services/equipment",
    icon: faToolbox,
    isInternal: false,
  },
  {
    name: "Resources",
    path: "https://www.bywaters.co.uk/recycling-posters",
    icon: faFolderOpen,
    isInternal: false,
  },
  {
    name: "Donate",
    path: "/dashboard/donate",
    icon: faTruckPickup,
    isInternal: true,
  },
];

// Miscellaneous
export const wasteTypesDetailTableHeader = ["Waste Type", "t.", "%"];

export const wasteTypesGraphColors = [
  {
    labelGroup: [
      "Hazardous Sharp Incineration",
      "High Temperature Incineration",
      "Waste for Incineration",
    ],
    color: "#212649",
  },
  {
    labelGroup: ["Dry Mixed Recycling", "Dry Mixed Recycling with Glass"],
    color: "#ff5100",
  },
  {
    labelGroup: ["CAT 3 Food waste – not for human consumption"],
    color: "#579495",
  },
  {
    labelGroup: [
      "Glass (Cullett)",
      "Glass (Cullett)  Outgoing",
      "Construction Glass",
    ],
    color: "#248951",
  },
  {
    labelGroup: [
      "Lithium Ion Batteries",
      "Mixed Portable Batteries",
      "Ni-Cd batteries",
      "Nickel Metal Hydride batteries",
      "NiCad Batteries",
      "Lead Acid Batteries",
    ],
    color: "#de0072",
  },
  {
    labelGroup: ["Bulky Waste"],
    color: "#00adef",
  },
  {
    labelGroup: ["Cardboard", "Paper and Cardboard Packaging"],
    color: "#d67950",
  },
  {
    labelGroup: ["Coffee Grounds"],
    color: "#5b473e",
  },
  {
    labelGroup: [
      "Confidential",
      "Confidential for Incineration",
      "Confidential Media Material",
      "Confidential Waste",
      "Confidential Textiles for Destruction",
    ],
    color: "#5f5f5f",
  },
  {
    labelGroup: ["Edible Oil and Fat", "Oil"],
    color: "#f1c451",
  },
  {
    labelGroup: ["Green Waste", "Wood"],
    color: "#42a287",
  },
  {
    labelGroup: [
      "Paints Inks Adhesives and Resins",
      "Waste Paint and Varnish (Haz)",
      "Waste Paint and Varnish (Non-Haz)",
      "Waste Paint & Varnish Remover",
    ],
    color: "#4fc7e9",
  },
  {
    labelGroup: ["Toner Cartridges"],
    color: "#64be7e",
  },
];

export const bradServicesRowParagraphs = [
  `
    Bywaters provides a variety of waste management services, handling all forms of waste
    sustainably in order to increase your recycling rates and reduce emissions.
  `,
  `
    Whether you require a skip, wheelie bin or compactor, we have the waste management
    equipment you'll need for the task in hand.
  `,
  `
    We have made our recycling posters and resources available for you to download.
  `,
];

export const tableJobsHeader = [
  "Job Date",
  "Site",
  "Job Number",
  "Arr. Time",
  "Dep. Time",
  "Status",
  "Service",
  "Waste Type",
  "EWC Code",
  "Weight",
  "Quantity",
  "CO2 Emissions (kgs)",
  "Download",
];

export const tableIssuesHeader = [
  "Job Date",
  "Site",
  "Job Number",
  "Job Status",
  "Job Issue Type",
  "Responsibility",
  "Issue Status",
  "Affects Service Rate",
];

export const tableTippingJobsHeader = [
  "Date",
  "Vehicle Reg No",
  "Round",
  "Ticket",
  "Arrival Time",
  "Departure Time",
  "Turn Around Time",
  "Gross Weight",
  "Tare Weight",
  "Net Weight",
  "Contamination Level",
  "Gate Fee",
  "Total Fee",
];

export const invoiceTableHeader = [
  "Document Number",
  "Document Type",
  "Invoice Date",
  "Net Amount",
  "Linked Invoice",
];

export const tableDocumentsHeader = [
  "Site",
  "Doc Ref",
  "File Name",
  "End of Validity",
  "Doc Type",
];

export const genericDocumentsTable = [
  "Document Type",
  "Customer Name",
  "File Name",
  "File Type",
  "Last Modified Date",
];

export const weightronApiListHeader = [
  "Client",
  "Weightron UID",
  "Connection Status",
  "Last Updated",
  "Test Connection",
  "Edit",
  "Delete",
];

export const jobStatusSelectorList: JobStatusDataEntry[] = [
  { label: "New", value: JobStatus.NEW },
  { label: "Allocated", value: JobStatus.ALLOCATED },
  { label: "On Stop", value: JobStatus.ON_STOP },
  { label: "Cancelled", value: JobStatus.CANCELLED },
  { label: "Completed", value: JobStatus.COMPLETED },
  { label: "Failed", value: JobStatus.FAILED },
  { label: "Postponed", value: JobStatus.POSTPONED },
];

export const invoiceTypeSelectorList = [
  { label: "Invoice", value: InvoiceType.INVOICE },
  { label: "Credit Note", value: InvoiceType.CREDIT },
];

export const documentTypeSelectorList = [
  { label: "Contract Attachment", value: DocumentType.CONTRACT_ATTACHMENT },
  { label: "Agreement Attachment", value: DocumentType.AGREEMENT_ATTACHMENT },
  { label: "Duty of Care", value: DocumentType.DUTY_OF_CARE },
  {
    label: "Contract Attachment (SF)",
    value: DocumentType.CONTRACT_ATTACHMENT_SF,
  },
  { label: "WTN Attachment (SF)", value: DocumentType.WTN_ATTACHMENT_SF },
];

export const achievementDataTemplate = [
  {
    icon: "/images/kpi_icons/service-rate.png",
    altText: "service_rate",
    title: "Service Rate",
    unit: "%",
  },
  {
    icon: "/images/kpi_icons/waste.png",
    altText: "waste",
    title: "Total Waste",
    unit: "t",
  },
  {
    icon: "/images/kpi_icons/recycle.png",
    altText: "recycle",
    title: "Recycled Waste",
    unit: "t",
  },
  {
    icon: "/images/kpi_icons/incinerate.png",
    altText: "incinerate",
    title: "Waste for Incineration",
    unit: "t",
  },
  {
    icon: "/images/kpi_icons/recycle-rate.png",
    altText: "recycle-rate",
    title: "Recycling Rate",
    unit: "%",
  },
  {
    icon: "/images/kpi_icons/incinerate-rate.png",
    altText: "incinerate-rate",
    title: "Incineration Rate",
    unit: "%",
  },
  {
    icon: "/images/kpi_icons/energy.png",
    altText: "energy",
    title: "Homes Powered per Day",
  },
  {
    icon: "/images/kpi_icons/co2-produced.png",
    altText: "co2-produced",
    title: "CO2 Emissions Generated",
    unit: "t",
  },
  {
    icon: "/images/kpi_icons/co2-saved.png",
    altText: "co2-saved",
    title: "CO2 Saved",
    unit: "t",
  },
  {
    icon: "/images/kpi_icons/trees.png",
    altText: "trees",
    title: "Trees Saved",
  },
];

export const achievementTippingDataIcons = [
  "/images/kpi_icons/waste.png",
  "/images/kpi_icons/recycle-rate.png",
  "/images/kpi_icons/energy.png",
  "/images/kpi_icons/service-rate.png",
  "/images/kpi_icons/incinerate-rate.png",
];

export const excelFileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
export const excelFileExtension = ".xlsx";

export const bywatersLinkedin = "https://www.linkedin.com/company/bywaters/";
export const bywatersFacebook = "https://www.facebook.com/Bywaters.co.uk";
export const bywatersInstagram = "https://www.instagram.com/bywatersuk/?hl=en";

export const linkedInShareID = "72113602342362153001";

// Help Subjects
export const subjectList = [
  "Subject",
  "New services",
  "New equipment",
  "Request and amendment (permanent)",
  "Request and amendment (temporary)",
  "Request a waste audit",
  "Request a Waste Awareness day",
  "Other",
];

// Level color codes
export const levelColorCodes = [
  "#1F77B4", // Level 1
  "#F77F0E", // Level 2
  "#2CA02C", // Level 3
  "#D62728", // Level 4
  "#9467BD", // Level 5
];
